import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useGuestStore } from '~/store/guest'
import { useResetState } from '~/composables/useResetState'

export default defineNuxtRouteMiddleware(async (to) => {
  // Ignore devtools requests
  if (
    to.path.startsWith('/.well-known/') ||
    to.meta.skipMiddleware ||
    import.meta.server
  )
    return

  const { gift: giftQueryParam, partner } = to.query
  const guestStore = useGuestStore()

  if (giftQueryParam) {
    if (
      !guestStore.gift?.id ||
      guestStore.gift?.id !== String(giftQueryParam)
    ) {
      const { resetState } = useResetState()
      resetState()

      await guestStore.loadGift(giftQueryParam as string)

      if (!guestStore.gift?.id) {
        if (guestStore.requestError?.statusCode === 410) {
          return navigateTo('/expired')
        }
        return navigateTo('/welcome', { external: true })
      }
    }
  } else if (guestStore.gift?.id && !giftQueryParam && !partner) {
    // Preserve the gift query param if it's not present but a gift is already loaded
    return navigateTo({
      path: to.path,
      query: { ...to.query, gift: guestStore.gift?.id },
    })
  }
})
